import { HSActiveConfiguration } from './hs-active-configuration';

export class FoldingDoorActiveConfiguration extends HSActiveConfiguration {
    type: 'folding_door' = 'folding_door';
}
